import * as React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import PhoneCaseForm from '../PhoneCaseForm/PhoneCaseForm';
import { PHONE_CASE_FORM_DEFAULT_VALUES } from '../PhoneCaseForm/constants';
import { useModals } from 'hooks/useModals';
import { TPhoneCasesEdit } from './PhoneCasesEdit.types';
import { useAppDispatch, useAppSelector } from 'store/store';
import { TPhoneCaseFormValues } from '../PhoneCaseForm/PhoneCaseForm.types';
import {
  getPhoneCasesListAsyncThunk,
  updatePhoneCaseAsyncThunk,
} from 'store/phoneCases/phoneCases.action';
import { yupResolver } from '@hookform/resolvers/yup';
import { phoneCaseFormSchema } from '../PhoneCaseForm/PhoneCaseForm.schema';

const PhoneCasesEdit: TPhoneCasesEdit = ({ item }) => {
  const dispatch = useAppDispatch();
  const modals = useModals();

  const { isLoading: isUpdatePhoneCaseLoading } = useAppSelector(
    (store) => store.phoneCases.updatePhoneCase
  );

  const form = useForm({
    mode: 'onSubmit',
    reValidateMode: 'onChange',
    defaultValues: {
      ...PHONE_CASE_FORM_DEFAULT_VALUES,
      ...item,
    },
    resolver: yupResolver(phoneCaseFormSchema),
    shouldUnregister: true,
  });

  const handleSubmit = (
    data: TPhoneCaseFormValues,
    images: Array<File | string>
  ) => {
    dispatch(
      updatePhoneCaseAsyncThunk({
        id: item.id,
        body: { ...data, images, id: item.id },
        onSuccess: () => {
          modals.closeModal();
          dispatch(
            getPhoneCasesListAsyncThunk({
              queryParams: { page: 1, perPage: 1000 },
            })
          );
        },
      })
    );
  };

  return (
    <FormProvider {...form}>
      <PhoneCaseForm
        onSubmit={handleSubmit}
        defaultImageLinks={item.images}
        isLoading={isUpdatePhoneCaseLoading}
      />
    </FormProvider>
  );
};

export default PhoneCasesEdit;
